export type ReferralStatus = 'active' | 'archived'

/**
 * Document category ID for Referrals
 * Used in the presign/commit upload flow
 */
export const REFERRALS_CATEGORY_ID = '69846e21213cbccd4529f61e'

/**
 * Maximum number of attachments allowed per referral
 */
export const MAX_ATTACHMENTS = 3

export interface ReferralUser {
  _id: string
  name: string
}

export interface AttachmentFile {
  bucket: string
  etag: string
  filename: string
  mimetype: string
  path: string
  size: number
  url: string
}

export interface ReferralAttachment {
  _id: string
  home: string
  resident: string
  name: string
  pdf: AttachmentFile
  createdAt: string
  attachedToCarePlan: boolean
  originalFile: string
  __v: number
}

export interface Referral {
  _id: string
  home: string
  subjectOfCare: string
  reasonForReferral: string
  referredTo: string
  referralDate: string
  attachments: ReferralAttachment[]
  status: ReferralStatus
  createdBy: ReferralUser
  updatedBy?: ReferralUser
  archivedBy?: ReferralUser | Record<string, never>
  createdAt: string
  updatedAt?: string
  archivedAt?: string
}

export interface CreateReferralInput {
  resident: string
  reasonForReferral: string
  referredTo: string
  referralDate: string
}

export interface UpdateReferralInput {
  _id: string
  reasonForReferral?: string
  referredTo?: string
  referralDate?: string
}
